<template>

  <div>
    <el-table
        v-loading="loading"
        :data="data"
        style="width: 100%">

      <el-table-column
          prop="created_at"
          :label="$t('created_at')">
        <template slot-scope="scope">
          <i class="el-icon-time"></i> {{ scope.row.created_at | moment("YYYY-MM-DD HH:mm") }}
        </template>
      </el-table-column>


      <el-table-column
          :label="$t('stream')">
        <template slot-scope="scope">
          {{ scope.row.stream.name }}

        </template>
      </el-table-column>

      <el-table-column
          :label="$t('offer')">
        <template slot-scope="scope">
          {{ scope.row.offer.name }}
        </template>
      </el-table-column>

      <el-table-column
          label="URL">
        <template slot-scope="scope">
          <el-popover
              placement="bottom"
              trigger="click">
            <code>{{ scope.row.url }}</code>
            <div slot="reference">
              <el-button type="text" >{{ scope.row.url }}</el-button>
            </div>
          </el-popover>

        </template>
      </el-table-column>

      <el-table-column
          :label="$t('response')">
        <template slot-scope="scope">
          <el-popover
              placement="bottom"
              trigger="click">
            <code>{{ scope.row.response }}</code>
            <div slot="reference">
              <el-button type="text">{{ scope.row.response }}</el-button>
            </div>
          </el-popover>
        </template>
      </el-table-column>

      <el-table-column
          :label="$t('status_code')">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status_code === 200" disable-transitions>{{ scope.row.status_code }}</el-tag>
          <el-tag type="danger" v-if="scope.row.status_code !== 200" disable-transitions>{{ scope.row.status_code }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column
          :label="$t('failures')">
        <template slot-scope="scope">
          {{ scope.row.failures }}
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-count="total_pages">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "Postback",
  data () {
    return {
      loading: false,
      data: [],
      page: 1,
      total_pages: 0
    }
  },
  created () {
    this.fetchData();
  },
  methods: {
    fetchData () {
      this.loading = true;
      this.$axios.get('/postback?page=' + this.page).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.total_pages = parseInt(res.headers['x-pagination-page-count']);
      })
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData()
    },
  }
}
</script>

<style scoped>

</style>